import { SectionNames } from './SectionDataMetaData';

// Payload structure of the action: {fieldName, value} 
function portalSettingsReducer(state, action) {
    // Switch cases based on section names
    switch (action.type) {
        case SectionNames.ImagesTab:
        case SectionNames.ARPageTab:
        case SectionNames.MenuListingTab:
        case SectionNames.MenuDetailsPopupTab:
        case SectionNames.CartTab:
        case SectionNames.CheckoutTab:
        case SectionNames.OrderSuccessTab:
        case SectionNames.OrderHistoryTab:
        case SectionNames.OrderDetailsTab:
        case SectionNames.AddAddressTab:
        case SectionNames.AddressListTab:
        case SectionNames.PaymentSettingsTab:
        case SectionNames.MultiLanguageTab:
        case SectionNames.TableOrderingMenuLayoutTab:
            return {
                ...state,
                [action.type]: {
                    ...state[action.type],
                    [action.payload.fieldName]: action.payload.value
                },
            }

        case SectionNames.socialMediaTab:
        case SectionNames.categoryGroupsTab:
            return {
                ...state,
                [action.type]: action.payload
            }
        case "STATE":
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}
export default portalSettingsReducer;